module.exports = __webpack_public_path__ + "img/outlander2022_drive.d3490c58.jpg";